import React from 'react'
import { Customer } from '../../types/search.types'
import './CustomerTable.styles.css'

interface CustomerTableProps {
  customers: Customer[]
  loading?: boolean
  onSelectCustomer: (customer: Customer) => void
}

export const CustomerTable: React.FC<CustomerTableProps> = ({
  customers,
  loading = false,
  onSelectCustomer
}) => {
  if (loading) {
    return (
      <div className="customer-table-container">
        <div className="customer-table-loading">
          <div className="loading-spinner"></div>
          <p>Chargement des clients...</p>
        </div>
      </div>
    )
  }

  if (customers.length === 0) {
    return (
      <div className="customer-table-container">
        <div className="customer-table-empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          <h3>Aucun client trouvé</h3>
          <p>Modifiez vos critères de recherche</p>
        </div>
      </div>
    )
  }

  return (
    <div className="customer-table-container">
      <table className="customer-table">
        <thead>
          <tr>
            <th>Nom complet</th>
            <th>Email</th>
            <th>Téléphone</th>
            <th>ID Client</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr 
              key={customer.id}
              onClick={() => onSelectCustomer(customer)}
              className={customer.hasAccount ? 'has-account' : 'no-account'}
            >
              <td>
                <div className="customer-name">
                  <div className="customer-avatar">
                    {customer.firstName.charAt(0)}{customer.lastName.charAt(0)}
                  </div>
                  <span>{customer.firstName} {customer.lastName}</span>
                </div>
              </td>
              <td>
                <span className={customer.email ? 'customer-email' : 'empty-field'}>
                  {customer.email || '—'}
                </span>
              </td>
              <td>
                <span className={customer.phone ? 'customer-phone' : 'empty-field'}>
                  {customer.phone || '—'}
                </span>
              </td>
              <td>
                <span className="customer-id">{customer.fmClientId}</span>
              </td>
              <td>
                <span className={`status-badge ${customer.hasAccount ? 'status-active' : 'status-inactive'}`}>
                  {customer.hasAccount ? 'Compte actif' : 'Pas de compte'}
                </span>
              </td>
              <td>
                <button 
                  className="action-button"
                  onClick={(e) => {
                    e.stopPropagation()
                    onSelectCustomer(customer)
                  }}
                >
                  {customer.hasAccount ? 'Voir expertises' : 'Voir FM'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default CustomerTable